module.exports = __webpack_public_path__ + "static/media/yyt-logo.2f490d86.png";